import { startCase } from 'lodash'
import { TOP_UP_PACKAGES } from "../constants/topupPackages";

export const getTopupPackage = (key) => {
    return {
        label: TOP_UP_PACKAGES[key] ? TOP_UP_PACKAGES[key].name : startCase(key)
    }
};
